import { render, staticRenderFns } from "./BlendMaterial.vue?vue&type=template&id=46c44f60&scoped=true"
import script from "./BlendMaterial.vue?vue&type=script&lang=js"
export * from "./BlendMaterial.vue?vue&type=script&lang=js"
import style0 from "./BlendMaterial.vue?vue&type=style&index=0&id=46c44f60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c44f60",
  null
  
)

export default component.exports